import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { RepoPosition } from '../../models/repo-business/repo-business.model';
import { CommonService } from '../../services/common.service';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';

@Component({
  selector: 'app-position-edit',
  templateUrl: './position-edit.component.html',
  styleUrls: ['./position-edit.component.scss']
})
export class PositionEditComponent extends BaseUnsubscribeComponent implements OnInit {

  positionForm: FormGroup;
  private _position: RepoPosition;
  @Input() public set position(value: RepoPosition) {
    this._position = value;
  }
  public get position(): RepoPosition {
    return this._position;
  }
 

  @Output() positionSaved = new EventEmitter<RepoPosition>();
  @Output() positionValidationFailed = new EventEmitter<RepoPosition>();
  private selectedPositionId: number = 0;
  success$ = this.repoBusinessFacade.success$;
  constructor(private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly commonService: CommonService,
    private readonly toastService: ToastService) {
      super();
  }

  ngOnInit(): void {
    this.selectedPositionId = this.position?.positionId ?? 0;
    this.positionForm = RepoPosition.asFormGroup(this.position);
    this.attachEvents();
  }
  private attachEvents(): void {
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.savePosition) {
        this.toastService.success('Position Saved', 'Success!');
        this.repoBusinessFacade.loadPositions();
        this.positionSaved.emit(this.position);
      }
    });
  }

  public getFormData(): RepoPosition | null {
    if (this.positionForm.invalid) {
      for (var i in this.positionForm.controls) {
        this.positionForm.controls[i].markAsTouched();
      }
      this.positionValidationFailed.emit(this.position);
      return null;
    }
    if (this.positionForm) {
      const formData = this.positionForm.value;
      const position = RepoPosition.asObject(
        formData,
        this.selectedPositionId
      );
      return position;
    }
    return null;
  }
 
  public submitForm(): void {
    const position = this.getFormData();
    if (!position) {
      return;
    }
    this.repoBusinessFacade.savePosition(position);
   
  }

}
